import PropTypes from "prop-types"
import { useState } from "react"
import { connect } from "react-redux"

import { fetchStylecode, updateChoice } from "areas/product/store/actions"
import { Box, Typography } from "components/common"
import { to_currency } from "helpers/number"
import { filterProductOptions } from "helpers/product/product-filtering"

import { OptionsLabel, OptionsSelect } from "../components"

/* stylecode switcher as dropdown
   example product - JWLP0567-A
*/
const InternalSelectOptions = ({
  displayLabel,
  filters,
  options,
  pref,
  selectedValue,
  setChoice,
}) => {
  const [selectedChoice, setSelectedChoice] = useState(selectedValue)

  return (
    <Box pb={3} pt={1} px={2}>
      <OptionsLabel>{displayLabel}:</OptionsLabel>
      <OptionsSelect
        data-cy={`product-wizard-options-${pref}-dropdown`}
        onChange={(e) => {
          setSelectedChoice(e.target.value)
          setChoice(e, filters)
        }}
        value={selectedChoice}
      >
        {filterProductOptions(options, filters, true).map((opt) => (
          <option key={`choice_select_${opt.value}`} value={opt.value}>
            {opt.display_name}
            {opt.price > 0 ? " (+" + to_currency(opt.price) + ")" : ""}
          </option>
        ))}
      </OptionsSelect>
    </Box>
  )
}

const mapStateToProps = (state, ownProps) => {
  return {
    filters: state.choices,
    selectedValue:
      state.choices[ownProps.pref] && state.choices[ownProps.pref].value,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setChoice: (e, filters) => {
      const val = e.target.value
      const formattedOptions = filterProductOptions(
        ownProps.options,
        filters,
        true
      )
      const option = formattedOptions.find((opt) => opt.value === val)
      if (option.style_code) {
        dispatch(fetchStylecode(option.style_code))
      } else {
        dispatch(updateChoice(ownProps.pref, option, true))
      }
    },
  }
}

InternalSelectOptions.propTypes = {
  displayLabel: PropTypes.string,
  filters: PropTypes.object,
  options: PropTypes.array,
  pref: PropTypes.string,
  selectedValue: PropTypes.string,
  setChoice: PropTypes.func,
}

const SelectOptions = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalSelectOptions)

export default SelectOptions
